import axiosInstance from '../api/axiosConfig';
import { Estado, Cidade } from '../../types/endereco/endereco';
import { getApiBaseUrl } from '../baseUrl';

const PATH_V1_ENDERECOS = '/enderecos';

export async function getAllEstados(): Promise<Estado[]> {
  const apiUrl = getApiBaseUrl();
  const response = await axiosInstance.get(`${apiUrl}${PATH_V1_ENDERECOS}/estados`);
  return response.data;
}

export async function getEstadoById(id: number): Promise<Estado> {
  const apiUrl = getApiBaseUrl();
  const response = await axiosInstance.get(`${apiUrl}${PATH_V1_ENDERECOS}/estados/${id}`);
  return response.data;
}

export async function getCidadesByEstadoId(estadoId: number): Promise<Cidade[]> {
  const apiUrl = getApiBaseUrl();
  const response = await axiosInstance.get(`${apiUrl}${PATH_V1_ENDERECOS}/estados/${estadoId}/cidades`);
  return response.data;
}

export async function getCidadeById(id: number): Promise<Cidade> {
  const apiUrl = getApiBaseUrl();
  const response = await axiosInstance.get(`${apiUrl}${PATH_V1_ENDERECOS}/cidades/${id}`);
  return response.data;
}